import React from "react";
import { Box, VStack, useColorModeValue } from "@chakra-ui/react";
import RiskReviewPageHeader from "./RiskReviewPageHeader";

const RiskReviewPageShell = ({ title, description, actions, children, pb = 6 }) => {
  const pageBg = useColorModeValue("gray.50", "gray.900");

  return (
    <Box bg={pageBg} minH="100%" p={{ base: 3, md: 5, xl: 6 }} pb={pb}>
      <VStack align="stretch" spacing={6}>
        <Box
          px={{ base: 1, md: 0 }}
          pt={{ base: 1, md: 0 }}
        >
          <RiskReviewPageHeader
            title={title}
            description={description}
            actions={actions}
          />
        </Box>
        {children}
      </VStack>
    </Box>
  );
};

export default RiskReviewPageShell;
